import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {PressureConfig, PressureConfigJson} from './pressure-config';

export type PressureStepSizeConfigJson =  {
  labels: PressureConfigJson;
  lines: PressureConfigJson;
};

export class PressureStepSizeConfig implements JsonConfigInterface<PressureStepSizeConfigJson> {

  public readonly labels: PressureConfig = new PressureConfig();
  public readonly lines: PressureConfig = new PressureConfig();

  constructor(json?: PressureStepSizeConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public deserializeJson(json: PressureStepSizeConfigJson): void {
    this.labels.deserializeJson(json.labels);
    this.lines.deserializeJson(json.lines);
  }
}
